import { isSafari, ua } from '../whatBrowser';

const shouldUseLegacyBuild = () => {
    try {
        if (typeof window === 'undefined') return false;
        if (isSafari) {
            // Extract Safari version - matches "Version/18" format
            const match = ua.match(/Version\/(\d+)/i)
            console.log('Safari version:', match)
            if (!match || !match[1]) return true // If we can't determine version, use legacy to be safe

            const version = parseInt(match[1])
            return version < 18 // Use legacy build for Safari versions equal or below 18
        }
        return false
    } catch {
        return false;
    }
};

// Function to initialize PDF worker
const initPDFWorker = async () => {
    if (typeof window === 'undefined') return;

    // Lazy import to avoid SSR/test environments pulling in pdf.js eagerly
    const { pdfjs } = await import('react-pdf');

    try {
        const useLegacy = shouldUseLegacyBuild();
        // Use local worker file instead of unpkg

        const workerSrc = useLegacy
            ? new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).href
            : new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).href;

        pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
        pdfjs.GlobalWorkerOptions.workerPort = null;
    } catch (e) {
        console.error('Error setting PDF worker:', e);
    }
};

export default initPDFWorker;
